/* Brand mark and the shared back affordance used in the top bar's leading slot. */

import { escapeHtml } from '../utils/html.js';
import { ICONS } from './icons.js';

/** Brand badge markup. `size` is a Tailwind h-/w- utility pair. */
export function logoMark(className = '') {
  return `
    <div
      class="inline-flex select-none items-baseline tracking-[-0.045em] ${className}"
      aria-label="SprintSpeak"
    >
          <span class="font-bold text-neutral-950">
        Sprint
      </span>
      <span class="font-bold text-indigo-700">
        Speak
      </span>
    </div>
  `;
}

/**
 * The app's single back affordance for the top bar's leading slot: a left
 * chevron plus label. Views hand this to `renderAppScreen({ leading })` so "go
 * back" looks and behaves identically everywhere.
 *
 * The `data-back` hook makes `renderAppScreen` route the click through
 * `goBack()`, i.e. pop the history entry, so the previous screen comes back with
 * its scroll position intact. `href` is only the fallback for when there is no
 * app entry to pop (a cold start straight into this screen) — it still needs to
 * be a real route so the link stays meaningful.
 *
 * @param {string} [href='#/'] Hash route to fall back to (defaults to home).
 * @param {string} [text='Powrót'] Visible label.
 */
export function backButton(href = '#/', text = 'Powrót') {
  return `
    <a href="${escapeHtml(href)}" data-back aria-label="${escapeHtml(text)}"
      class="-ml-1 inline-flex items-center gap-1 text-xs font-semibold text-neutral-700 transition active:text-neutral-900">
      ${ICONS.chevronLeft('h-5 w-5')}
      <span>${escapeHtml(text)}</span>
    </a>`;
}
